
import { motion } from "framer-motion";
import { memo } from "react";

export const BackgroundPattern = memo(() => {
  return (
    <div 
      className="absolute inset-0 z-0 overflow-hidden"
      aria-hidden="true"
      role="presentation"
    >
      {/* Base grid pattern with improved animation - using CSS instead of images */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.8)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.8)_1px,transparent_1px)] bg-[length:40px_40px] opacity-30"></div>
      
      {/* Reduced number of animated elements and optimized animations */}
      <motion.div 
        className="absolute opacity-[0.02] top-0 right-0 w-[45%] h-[45%]"
        initial={{ opacity: 0.01 }}
        animate={{ 
          opacity: [0.01, 0.02, 0.01],
        }}
        transition={{ 
          duration: 20,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        {/* Using CSS for decoration instead of images */}
        <div className="w-full h-full bg-gradient-to-br from-blue-100/10 to-sky-100/10 blur-xl rounded-full"></div>
      </motion.div>
      
      <motion.div 
        className="absolute opacity-[0.02] bottom-[-5%] left-[5%] w-[50%] h-[50%]"
        initial={{ opacity: 0.01 }}
        animate={{ 
          opacity: [0.01, 0.02, 0.01],
        }}
        transition={{ 
          duration: 25,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 5
        }}
      >
        {/* Using CSS for decoration instead of images */}
        <div className="w-full h-full bg-gradient-to-tl from-emerald-100/10 to-teal-100/10 blur-xl rounded-full"></div>
      </motion.div>
      
      {/* Decorative elements - using pure CSS */}
      <div className="absolute top-[30%] right-[20%] w-10 h-10 rounded-full bg-gradient-to-r from-sky-300/20 to-blue-300/20 blur-xl"></div>
      <div className="absolute bottom-[35%] left-[15%] w-16 h-16 rounded-full bg-gradient-to-r from-emerald-300/15 to-teal-300/15 blur-xl"></div>
      
      {/* Light beams */}
      <div className="absolute top-0 -right-10 w-[30%] h-[40%] bg-gradient-to-b from-sky-500/5 via-sky-300/3 to-transparent transform rotate-[25deg] blur-3xl"></div>
      <div className="absolute -bottom-20 -left-10 w-[35%] h-[40%] bg-gradient-to-t from-blue-500/5 via-blue-300/3 to-transparent transform -rotate-[15deg] blur-3xl"></div>
    </div>
  );
});

BackgroundPattern.displayName = 'BackgroundPattern';
